<form>
  <input
    #inputs
    name="day"
    type="number"
    [(ngModel)]="day"
    placeholder="DD"
    required
    min="1"
    max="31"
    (keydown)="onKeyDown($event, 'start')"
    (input)="autoNext(0, 2, $event)"
  />
  <span>/</span>
  <input
    #inputs
    name="month"
    type="number"
    [(ngModel)]="month"
    placeholder="MM"
    required
    min="1"
    max="12"
    (keydown)="onKeyDown($event)"
    (input)="autoNext(1, 2, $event)"
  />
  <span>/</span>
  <input
    #inputs
    name="year"
    type="number"
    [(ngModel)]="year"
    placeholder="YYYY"
    required
    min="1900"
    max="3000"
    (keydown)="onKeyDown($event)"
    (input)="autoNext(2, 4, $event)"
  />

  <span>&nbsp;&nbsp;</span>

  <input
    #inputs
    name="hour"
    type="number"
    [(ngModel)]="hour"
    placeholder="HH"
    min="0"
    max="23"
    (keydown)="onKeyDown($event)"
    (input)="autoNext(3, 2, $event)"
  />
  <span>:</span>
  <input
    #inputs
    name="min"
    type="number"
    [(ngModel)]="min"
    placeholder="mm"
    min="0"
    max="59"
    (keydown)="onKeyDown($event, 'end')"
  />
</form>
